import Vivus from 'vivus';

export const cardIntoView = {
  targets: [],
  options: {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0.5
  },
  init: ()=>{
    if(document.getElementById('kv')){

      const philosophy = new Vivus("title--philosophy", {
        duration: 50,
        start: "manual",
        type: "oneByOne"
      });

      const partners = new Vivus("title--partners", {
        duration: 50,
        start: "manual",
        type: "oneByOne"
      });

      //アニメーションターゲット
      cardIntoView.targets = document.querySelectorAll('.js-card');
      //初期化
      const observer = new IntersectionObserver(callback, cardIntoView.options);
      //コールバック
      function callback(entries, observer){
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('js-card--show');
            if(entry.target.querySelector('#title--philosophy')){
              setTimeout(()=>{
                philosophy.play();
              }, 400);
            }else if(entry.target.querySelector('#title--partners')){
              setTimeout(()=>{
                partners.play();
              }, 400);
            }
            observer.unobserve(entry.target);
          }
        });
      }

      cardIntoView.targets.forEach((target) => {
        observer.observe(target);
      });
    }
  }
}
